import { apiRequest } from "../../../api/httpClient";

export interface PublicProjectionGraveEntry {
  graveId: string;
  graveCode: string;
  state: "PUBLISHED" | "WITHDRAWN";
  martyrPublicStatus?: "PUBLISHED" | "RESTRICTED" | null;
}

export interface PublicProjectionPreviewData {
  cemeteryId: string;
  tourState: "OPEN" | "CLOSED";
  assetStale: boolean;
  contentVersion: number;
  releasedVersion: number;
  graves: PublicProjectionGraveEntry[];
}

export interface PublicTourStateData {
  cemeteryId: string;
  state: "OPEN" | "CLOSED";
  contentVersion: number;
}

export interface GravePublicStatusData {
  graveId: string;
  state: "PUBLISHED" | "WITHDRAWN";
  version: number;
  assetStale: boolean;
}

export function getPublicProjectionPreview(cemeteryId: string): Promise<PublicProjectionPreviewData> {
  return apiRequest<PublicProjectionPreviewData>(
    `/cemeteries/${encodeURIComponent(cemeteryId)}/public-projection/preview`,
    {
      method: "GET",
    }
  );
}

export function updateCemeteryPublicTour(
  cemeteryId: string,
  state: "OPEN" | "CLOSED"
): Promise<PublicTourStateData> {
  return apiRequest<PublicTourStateData>(`/cemeteries/${encodeURIComponent(cemeteryId)}/public-tour`, {
    method: "PUT",
    body: JSON.stringify({ state }),
  });
}

export function updateGravePublicStatus(
  cemeteryId: string,
  graveId: string,
  state: "PUBLISHED" | "WITHDRAWN",
  reason?: string
): Promise<GravePublicStatusData> {
  return apiRequest<GravePublicStatusData>(
    `/cemeteries/${encodeURIComponent(cemeteryId)}/graves/${encodeURIComponent(graveId)}/public-status`,
    {
      method: "PUT",
      body: JSON.stringify({ state, reason }),
    }
  );
}
